import { createAction } from '@reduxjs/toolkit';

export const setFreeText = createAction<
  {
    [textKey: string]: string;
  },
  'SET_FREE_TEXT'
>('SET_FREE_TEXT');
